import React from 'react'
import { useLocation } from 'react-router-dom';

const TypeEmail = ({ email, setEmail, errorMessage, setErrorMessage, checkEmail }) => {

    const location = useLocation()
    const submitEmail = () => {
        const emailInput = document.getElementById('email');
        if (emailInput.validity.valid) {
            checkEmail()
        } else {
            emailInput.reportValidity()
        }
    }

    return (
        <div className="w-full">
            <div className="space-y-4 md:space-y-6">
                <h1 className={"leading-tight tracking-tight text-gray-900 " + (location.pathname === '/s%C3%A6lgbog' ? "text-base xl:text-lg font-medium" : "text-xl md:text-2xl font-bold")}>
                    Log ind eller opret konto
                </h1>
                {(errorMessage !== '') ?
                    <div className="text-center text-sm w-full py-4 px-2 bg-red-200">
                        <p>{errorMessage}</p>
                    </div>
                :
                    ""
                }
                <div className="space-y-4 md:space-y-6">
                    <div>
                        <label for="email" className="block mb-2 text-sm font-medium text-gray-900">Email</label>
                        <input type="email" name="email" id="email" autoComplete='off' autoFocus className="bg-gray-50 border border-gray-300 text-gray-900 block w-full p-2.5 outline-none text-sm sm:text-base" value={email} onChange={(e) => setEmail(e.target.value) & setErrorMessage('')} onKeyDown={(e) => e.key === 'Enter' ? submitEmail() : ""} required />
                    </div>
                    <button type="submit" onClick={submitEmail} className="focus:bg-pos-100 w-full text-white bg-gradient-to-r from-emerald-600 to-emerald-700 bg-pos-0 bg-size-200 hover:bg-pos-100 transition-all duration-150 ease-in-out outline-none font-medium text-sm px-5 py-2.5 text-center">Fortsæt</button>
                </div>
            </div>
        </div>
    )
}

export default TypeEmail;